const Dashboard = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/components/rapsotec/steering/Dashboard.vue"
  );
const ProjectsTimeline = () =>
  import(
    /* webpackChunkName: "ProjectsTimeline" */ "@/components/rapsotec/steering/ProjectsTimeline.vue"
  );
const ProjectManagerKpi = () =>
  import(
    /* webpackChunkName: "ProjectManagerKpi" */ "@/components/rapsotec/steering/ProjectManagerKpi.vue"
  );
import { STEERING_PAGES } from "@/utils/steering";

export default [
  {
    path: "/",
    name: STEERING_PAGES.DASHBOARD,
    component: Dashboard,
  },
  {
    path: "project-timeline",
    name: STEERING_PAGES.PROJECT_TIMELINE,
    component: ProjectsTimeline,
  },
  {
    path: "manager-kpi",
    name: STEERING_PAGES.PROJECT_MANAGER_KPI,
    component: ProjectManagerKpi,
  },
];
